import { Button, Field, Input } from '@aurea/ui';
import { useMutation, useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthCard } from '../components/AuthCard';
import { api } from '../lib/api';
import { useErrorText } from '../lib/i18n';

export const Route = createFileRoute('/setup/$token')({ component: Setup });

function Setup() {
  const { token } = Route.useParams();
  const { t } = useTranslation();
  const errorText = useErrorText();
  const navigate = useNavigate();
  const info = useQuery({ queryKey: ['setup', token], queryFn: () => api.setupInfo(token), retry: false });
  const save = useMutation({
    mutationFn: (password: string) => api.setup(token, password),
    onSuccess: () => navigate({ to: '/' }),
  });

  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    save.mutate(String(new FormData(e.currentTarget).get('password')));
  };

  if (info.isError)
    return (
      <AuthCard title={t('setup.title')} lead={errorText(info.error)}>
        {null}
      </AuthCard>
    );
  return (
    <AuthCard
      title={t('setup.title')}
      lead={info.data && t('setup.hello', { name: info.data.firstName, email: info.data.email })}
    >
      <form className="flex flex-col gap-4" onSubmit={submit}>
        <input
          type="email"
          name="username"
          autoComplete="username"
          value={info.data?.email ?? ''}
          readOnly
          hidden
        />
        <Field
          label={t('setup.password')}
          hint={t('setup.hint')}
          error={save.isError ? errorText(save.error) : undefined}
        >
          <Input
            name="password"
            type="password"
            autoComplete="new-password"
            minLength={10}
            required
            autoFocus
          />
        </Field>
        <Button type="submit" loading={save.isPending} disabled={!info.data}>
          {t('setup.submit')}
        </Button>
      </form>
    </AuthCard>
  );
}
